// Hosts served over plain http: a local dev server, however it is reached.
// Previously this was the single literal 'localhost:3000', so any other local
// address — a second branch on another port, or the machine's LAN IP when
// testing from a phone — had its redirects built as https://, pointing at a
// port with no TLS listener. Every redirect then died, which looks like the
// app is broken rather than the URL.
//
// Cannot match a deployed host: those are domain names, never localhost or a
// private-range IP.
const LOCAL_HOST =
  /^(localhost|127\.0\.0\.1|\[::1\]|10\.\d+\.\d+\.\d+|192\.168\.\d+\.\d+|172\.(1[6-9]|2\d|3[01])\.\d+\.\d+)(:\d+)?$/;

export const createUrl = (host, path = '') => {
  const protocol = LOCAL_HOST.test(host) ? 'http' : 'https';
  return `${protocol}://${host}${path}`;
};

export const getHost = (ctx): string =>
  ctx && ctx.req ? ctx.req.headers.host : window.location.host;

type CtxType = {
  req?: any;
  res?: any;
};

export const isServerRender = (ctx: CtxType = {}): boolean =>
  !!ctx.req && !!ctx.res;

// A real document navigation, not a client-side route change.
//
// Needed wherever peikko hands control back to getRedirect: toosa sets the
// `token` cookie httpOnly, so client-side JS cannot see it and an in-browser
// getRedirect would conclude the user is logged out. Only a real request
// carries the cookie where SSR can read it. A fresh document also remounts
// pages, which `key={router.route}` otherwise prevents for a same-route
// query change.
//
// A named function so tests have something to assert on; jsdom will not let
// you spy on window.location.replace.
export const hardNavigate = (path: string): void => {
  window.location.replace(path);
};
